// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603261133/js/" + chunkId + "." + {"44":"dd9bc7e3","225":"8f6538e0","481":"b6f56775","486":"5eaf94e2","770":"dac42d4f"}[chunkId] + ".0.48793570168142186.chunk.js";
};